import React from "react";

const AddressLink = ({ facility }) => {
  return (
    <a
      href={`https://www.google.com/maps/place/${facility.address}, ${facility.city} ${facility.state}, ${facility.zip}`}
      className="btn card-link"
      target="_blank"
      rel="noopener noreferrer"
    >
      {facility.address}
      {facility.address2 && (
        <>
          <br />
          {facility.address2}
        </>
      )}
      <br />
      {facility.city}, {facility.state} {facility.zip}
    </a>
  );
};

export default AddressLink;
